import { type RequestedResponder } from '@atlassian/eoc-schedule-common';

export enum ChangeEvent {
	Add = 'add',
	Remove = 'remove',
	Replace = 'replace',
	Order = 'order',
}

export type Item = { key: string } & RequestedResponder<true, true>;

export type ParticipantListProps = {
	value: Item[];
	onChange: (value: Item[], event: ChangeEvent) => void;
	isDisabled?: boolean;
	onBlur?: () => void;
	onFocus?: () => void;
};
